import Vue      from "vue";
import App      from "./App.vue";
import router   from "./router";
import Vuex     from "vuex";
import axios    from "axios";
import VueAxios from "vue-axios";
// Vue 3rd party plugins
import vuetify  from "@/core/plugins/vuetify";
import VueApexCharts from 'vue-apexcharts';

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = "http://localhost:7788";

// Libraries
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

const store = new Vuex.Store({
                                 state    : {
                                     count  : 0,
                                     message: ""
                                 },
                                 actions  : {
                                     increment(context) {
                                         context.commit("increment");
                                     },
                                     decrement(context) {
                                         context.commit("decrement");
                                     },
                                     incrementAsync({commit}) {
                                         setTimeout(() => {
                                             commit("increment");
                                         }, 1000);
                                     },
                                     updateCount({commit}, count) {
                                         commit("updateCount", count);
                                     },
                                     updateMessage({commit}) {
                                         return new Promise((resolve, reject) => {
                                             Vue.axios.get("/Role/Role?page=1&count=10").then(response => {
                                                 commit("updateMessage", response);
                                                 resolve(response);
                                             }).catch(({response}) => {
                                                 reject(response);
                                                 console.log("response.data.errors, " + response.data.errors);
                                             });
                                         });
                                     }
                                 },
                                 mutations: {
                                     increment    : state => state.count++,
                                     decrement    : state => state.count--,
                                     updateCount  : (state, count) => (state.count = count),
                                     updateMessage: (state, message) => (state.message = message.data)
                                 },
                                 getters  : {
                                     getCount: state => {
                                         return state.count;
                                     }
                                 }
                             });

new Vue({
            router,
            store,
            vuetify,
            render: h => h(App)
        }).$mount("#app");
